export default __webpack_public_path__ + "static/media/6.ab05c9b7.webp";